const REGEX_LITERAL = /^\/([\s\S]*)\/([gimsuy]*)$/;

export const compilePattern = (raw) => {
  const source = String(raw || "");
  const literal = source.match(REGEX_LITERAL);
  if (!literal) return new RegExp(source);
  return new RegExp(literal[1], literal[2].replace(/[gy]/g, ""));
};
